import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import { ArrowLeft, Save, Camera } from "lucide-react";

export default function EditMember() {
  const { id } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  const [saving, setSaving] = useState(false);
  const [fonctionType, setFonctionType] = useState(
    location.state?.member?.fonction &&
      !["Membre Actif", "Responsable", "Coordinateur"].includes(
        location.state.member.fonction,
      )
      ? "Personnalisé"
      : location.state?.member?.fonction || "Membre Actif",
  );

  const [customFonction, setCustomFonction] = useState(
    location.state?.member?.fonction &&
      !["Membre Actif", "Responsable", "Coordinateur"].includes(
        location.state.member.fonction,
      )
      ? location.state.member.fonction
      : "",
  );

  const [member, setMember] = useState(
    location.state?.member || {
      nom: "",
      prenom: "",
      email: "",
      telephone: "",
      birthday: "",
      avatar: "",
    },
  );
  useEffect(() => {
    if (!location.state?.member) {
      navigate("/admin/members");
    }
  }, [location, navigate]);

  function handleChange(e) {
    const { name, value } = e.target;

    setMember((prev) => ({
      ...prev,

      [name]: value,
    }));
  }

  async function saveMember() {
    try {
      setSaving(true);

      const token = localStorage.getItem("membreToken");

      const res = await fetch("/api/admin/member?action=update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id,
          nom: member.nom,
          prenom: member.prenom,
          email: member.email,
          telephone: member.telephone,
          birthday: member.birthday,
          fonction: member.fonction,
        }),
      });

      const json = await res.json();

      if (!json.success) {
        throw new Error(json.message);
      }

      alert("✅ Membre modifié avec succès.");

      navigate(-1);
    } catch (err) {
      console.error(err);
      alert("Erreur lors de la modification.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-6 bg-white px-4 py-2 rounded-xl shadow"
        >
          <ArrowLeft size={18} />
          Retour
        </button>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
          <div className="bg-gradient-to-r from-blue-700 to-blue-600 text-white p-6">
            <h1 className="text-2xl font-bold">Modifier le membre</h1>

            <p className="opacity-90 mt-1">
              Modifier les informations du membre
            </p>
          </div>

          {/* PART 2 */}
          <div className="p-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Avatar */}

              <div className="flex flex-col items-center">
                {member.avatar ? (
                  <img
                    src={member.avatar}
                    alt=""
                    className="w-48 h-48 rounded-full object-cover border-4 border-blue-600 shadow-lg"
                  />
                ) : (
                  <div className="w-48 h-48 rounded-full bg-blue-600 text-white flex items-center justify-center text-6xl font-bold">
                    {member.prenom?.charAt(0).toUpperCase()}
                  </div>
                )}
              </div>

              {/* Form */}

              <div className="lg:col-span-2">
                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label className="font-semibold">Nom</label>

                    <input
                      type="text"
                      name="nom"
                      value={member.nom}
                      onChange={handleChange}
                      className="w-full mt-2 border rounded-xl p-3"
                    />
                  </div>

                  <div>
                    <label className="font-semibold">Prénom</label>

                    <input
                      type="text"
                      name="prenom"
                      value={member.prenom}
                      onChange={handleChange}
                      className="w-full mt-2 border rounded-xl p-3"
                    />
                  </div>

                  <div>
                    <label className="font-semibold">Email</label>

                    <input
                      type="email"
                      name="email"
                      value={member.email}
                      onChange={handleChange}
                      className="w-full mt-2 border rounded-xl p-3"
                    />
                  </div>

                  <div>
                    <label className="font-semibold">Téléphone</label>

                    <input
                      type="text"
                      name="telephone"
                      value={member.telephone}
                      onChange={handleChange}
                      className="w-full mt-2 border rounded-xl p-3"
                    />
                  </div>

                  <div>
                    <label className="font-semibold">Date de naissance</label>

                    <input
                      type="date"
                      name="birthday"
                      value={member.birthday}
                      onChange={handleChange}
                      className="w-full mt-2 border rounded-xl p-3"
                    />
                  </div>
                  <div>
                    <label className="font-semibold">Fonction</label>

                    <select
                      value={fonctionType}
                      onChange={(e) => {
                        setFonctionType(e.target.value);

                        if (e.target.value !== "Personnalisé") {
                          setMember((prev) => ({
                            ...prev,
                            fonction: e.target.value,
                          }));
                        } else {
                          setMember((prev) => ({
                            ...prev,
                            fonction: "",
                          }));
                        }
                      }}
                      className="w-full mt-2 border rounded-xl p-3"
                    >
                      <option>Membre Actif</option>
                      <option>Responsable</option>
                      <option>Coordinateur</option>
                      <option>Personnalisé</option>
                    </select>
                  </div>
                  {fonctionType === "Personnalisé" && (
                    <div>
                      <label className="font-semibold">
                        Nom de la fonction
                      </label>

                      <input
                        type="text"
                        value={customFonction}
                        onChange={(e) => {
                          setCustomFonction(e.target.value);

                          setMember((prev) => ({
                            ...prev,
                            fonction: e.target.value,
                          }));
                        }}
                        className="w-full mt-2 border rounded-xl p-3"
                        placeholder="Ex : Président"
                      />
                    </div>
                  )}
                </div>

                {/* PART 3 */}

                <div className="mt-8 flex flex-col md:flex-row gap-4">
                  <button
                    onClick={saveMember}
                    disabled={saving}
                    className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2"
                  >
                    <Save size={18} />

                    {saving ? "Enregistrement..." : "Enregistrer"}
                  </button>

                  <button
                    onClick={() => navigate(-1)}
                    className="flex-1 bg-gray-700 hover:bg-black text-white py-3 rounded-xl font-semibold"
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
